module.exports = __webpack_public_path__ + "3f38936c.png";